module.exports = __webpack_public_path__ + "../../../static/img/se_09.c8a97127.png";